const trackEvent = function(category, action, label) {
    var dataObject = {
        'event': 'MANUAL_EVENT',
        'eventCategory': category,
        'eventAction': action,
        'eventLabel': label
    };
    
    if(typeof dataLayer != 'undefined'){
        dataLayer.push(dataObject);
    }
}

export default trackEvent;